export const SET_PUBLISH_LOADED = "SET_PUBLISH_LOADED";
export const SET_PUBLISH_DOCUMENT = "SET_PUBLISH_DOCUMENT";
export const UPDATE_PUBLISH_DOCUMENT = "UPDATE_PUBLISH_DOCUMENT";
export const DELETE_TAG = "DELETE_TAG";
export const SET_DOCUMENT_LOCATIONS = "SET_DOCUMENT_LOCATIONS";
export const UPDATE_LOCATIONS = "UPDATE_LOCATIONS";
export const UPDATE_LESSON_LOCATIONS_SKIP = "UPDATE_LESSON_LOCATIONS_SKIP";
export const UPDATE_ATTACHMENTS = "UPDATE_ATTACHMENTS";
